import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  title: 'Health Card',
  content: [
    'It is important to replace your health card immediately if it has been lost or stolen to ensure you',
    'continue to have access to valuable health care services when needed. The steps to replace your health card vary',
    'by province, each of which are detailed below:',

    '<h6>Alberta</h6>',
    '<ul>',
    '<li>You can request a replacement:',
    '<ul>',
    '<li>By telephone at <a  href="tel:780-427-1432">780-427-1432</a> in Edmonton, or toll-free elsewhere in Alberta',
    'at 310-0000 then <a  href="tel:780-427-1432">780-427-1432</a></li>',
    '<li>In writing to Alberta Health, Attention: Alberta Health Care Insurance Plan, P.O. Box 1360, Station Main, Edmonton,',
    'AB T5J 2N3</li>',
    '<li>In person by visiting an authorized registry agent</li>',
    '</ul>',
    '</li>',
    '<li>You must provide your full name, mailing address, phone number, personal health care number and date of birth.</li>',
    '<li>Visit the Alberta Heath Care Insurance Plan website to check for any changes to this information.</li>',
    '</ul>',

    '<h6>Saskatchewan</h6>',
    '<ul>',
    '<li>Your Health Card can be easily replaced online.</li>',
    '<li>Alternatively, you can print and complete this document and mail or fax it to the contact information provided on the form.</li>',
    '</ul>',

    '<h6>Manitoba</h6>',
    '<ul>',
    '<li>Your Health Card can easily be replaced by completing the online form.</li>',
    '<li>Alternatively, contact the Insured Benefits Branch immediately by calling <a href="tel:204-786-7101">204-786-7101</a>',
    '(Winnipeg) or toll',
    'free at <a  href="tel:+1-800-392-1207">1-800-392-1207</a>. Call the Manitoba Relay Service at 711 or',
    '<a  href="tel:+1-800-432-4444">1-800-432-4444</a> to reach the above number.</li>',
    '<li>Visit the Manitoba Health Care Coverage website to check for any changes to this information.</li>',
    '</ul>',

    '<h6>Ontario</h6>',
    '<ul>',
    '<li>You can request a replacement by calling <a  href="tel:+1-800-664-8988">1-800-664-8988</a> if your name or address has',
    'not changed.</li>',
    '<li>If you have an old (red and white) health card, an expired health card, or your information has changed, you',
    'must visit a ServiceOntario centre. You will need to bring 3 original documents as follows:',
    '<ul>',
    '<li>one to prove citizenship/immigration status</li>',
    '<li>one to prove residency in Ontario</li>',
    '<li>one to prove identity</li>',
    '</ul>',
    '</li>',
    '</ul>',

    '<h6>Quebec</h6>',
    '<ul>',
    '<li>You can request a replacement by filling out the online form for a small fee.</li>',
    '<li>Alternatively, for an incremental fee, you may request a replacement card by calling the Régie at',
    '<a  href="tel:+1-800-561-9749">1-800-561-9749</a> (toll-free) or at <a  href="tel:514-864-3411">514-864-3411</a>',
    'from Montreal/Quebec.</li>',
    '<li>To get the replacement in person, visit one of the service points of the Régie.</li>',
    '<li>For convenience, you can replace both a health card and driver&#39;s licence  at the Société de l&#39;assurance',
    'automobile du Québec (SAAQ) Service outlets using same photo.</li>',
    '</ul>',

    '<h6>Newfoundland</h6>',
    '<ul>',
    '<li>Complete a card replacement form and return by mail or in person to Medical Care Plan (MCP).</li>',
    '<li>Forms are available at most doctors&#39; offices and hospitals in Newfoundland and Labrador and at MCP office',
    'at 45 Major&#39;s Path, St. John&#39;s. You can also print your own forms.</li>',
    '<li>If you do not know your MCP number, you will be asked to provide identification before receiving a new card.</li>',
    '</ul>',

    '<h6>New Brunswick</h6>',
    '<ul>',
    '<li>Visit your local Service New Brunswick office to request a replacement for a small fee.</li>',
    '<li>Alternatively, you can mail New Brunswick Medicare a cheque or money order made payable to the Minister of Finance,',
    'along with your completed replacement form.</li>',
    '<li>For questions related to the form you can contact Service New Brunswick&#39;s Teleservices toll-free at',
    '<a  href="tel:+1-888-762-8600">1-888-762-8600</a>.</li>',
    '<li>You will find the list of supporting documents on the replacement form itself.</li>',
    '</ul>',

    '<h6>Nova Scotia</h6>',
    '<ul>',
    '<li>Contact MSI Registration and Enquiry Department to request a replacement by phone at',
    '<a  href="tel:902-496-7008">902-496-7008</a> or',
    '<a  href="tel:+1-800-563-8880">1-800-563-8880</a> (toll free in Nova Scotia), or by email',
    '<a href="mailto:MSI@medavie.ca">MSI@medavie.ca</a>. A small fee applies.</li>',
    '</ul>',

    '<h6>PEI</h6>',
    '<ul>',
    '<li>Return your completed replacement of health card form to request a replacement for a small fee.</li>',
    '<li>If you require additional information regarding the form or the process you can contact Medicare Services at',
    '<a  href="tel:+1-800-321-5492">1-800-321-5492</a>.</li>',
    '</ul>'
  ].join('\n')
};
